var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpediente(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Organize-Diagram-Structure-Multitask-Files_Management",
    "data-name": "Organize-Diagram-Structure-Multitask-Files Management"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13 41 .82.82-1.82 6.18h-9v-2.1a6 6 0 0 1 3.56-5.48l2.74-1.22.7 2.8z",
    fill: "#3d9ae2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 45.9v2.1h-9l-1.82-6.18.82-.82 3 1 .7-2.8 2.74 1.22a6 6 0 0 1 3.56 5.48z",
    fill: "#3d9ae2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.7 39.2-.7 2.8-3-1-1-2 2-1z",
    fill: "#1e81ce"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 39-1 2-3 1-.7-2.8 2.7-1.2z",
    fill: "#1e81ce"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.18 41.82 1.82 6.18h-6l1.82-6.18 1.18 1.18z",
    fill: "#ff5023"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17 41-.82.82-1.18 1.18-1.18-1.18-.82-.82 1-2h2z",
    fill: "#ff5023"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57 45 4 4h-4a1 1 0 0 1 -1-1v-3z",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61 49v11a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1-1v-14a1 1 0 0 1 1-1h8v3a1 1 0 0 0 1 1z",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61 28v11a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1-1v-14a1 1 0 0 1 1-1h8v3a1 1 0 0 0 1 1z",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57 24 4 4h-4a1 1 0 0 1 -1-1v-3z",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61 7v11a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1-1v-14a1 1 0 0 1 1-1h8v3a1 1 0 0 0 1 1z",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57 3 4 4h-4a1 1 0 0 1 -1-1v-3z",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 35v3l-2 1h-2l-2-1v-3z",
    fill: "#ffc477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23 26h-2v4h2a2 2 0 0 0 0-4z",
    fill: "#ffb655"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 26h2v4h-2a2 2 0 0 1 0-4z",
    fill: "#ffb655"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 35v2.32a6.958 6.958 0 0 1 -6 0v-2.32z",
    fill: "#ffb655"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.34 25a3.014 3.014 0 0 1 -2.91-2.27l-.43-1.73a4 4 0 0 1 -4 4h-6v4a7 7 0 0 0 14 0v-4z",
    fill: "#ffc477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 23v2h-.66a3.014 3.014 0 0 1 -2.91-2.27l-.43-1.73a4 4 0 0 1 -4 4h-6v-2a7 7 0 1 1 14 0z",
    fill: "#57565c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61 9v9a1 1 0 0 1 -1 1h-9z",
    fill: "#d8d7da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61 30v9a1 1 0 0 1 -1 1h-9z",
    fill: "#d8d7da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61 51v9a1 1 0 0 1 -1 1h-9z",
    fill: "#d8d7da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 27h2v2h-2z",
    fill: "#ee8700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17 27h2v2h-2z",
    fill: "#ee8700"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#c6c5ca"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m50 31h8v2h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50 35h8v2h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50 27h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50 10h8v2h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50 14h8v2h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50 6h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50 52h8v2h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50 56h8v2h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50 48h2v2h-2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m38 12h6v-2h-6a3 3 0 0 0 -3 3v18h-5v2h5v18a3 3 0 0 0 3 3h6v-2h-6a1 1 0 0 1 -1-1v-18h7v-2h-7v-18a1 1 0 0 1 1-1z",
    fill: "#ffa733"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpediente);
export default __webpack_public_path__ + "static/media/expediente.6396fb2b4639e2c608091c1a18f8a3f7.svg";
export { ForwardRef as ReactComponent };